
import React, { useCallback, useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import MainHeader from "../pages/MainHeader";
import { useNavigate } from "react-router-dom";
import { routes } from "../routes/routes-names";
import { authService } from "../lib/api/auth";
import Swal from "sweetalert2";
import moment from "moment";
import { organizationService } from "../lib/api/organization";
import { LocalStorageManager } from '../lib/localStorage-manager';
import { tokenManager } from '../lib/token-manager';
import ResetPasswordFlow from "../forgotpassword/ResetPasswordRoutes"
import "bootstrap/dist/css/bootstrap.min.css";

const tsmclogo = require("../assets/images/TSMC_LOGO.jpg");
const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [isRegister, setIsRegister] = useState(false);
  const [loading, setLoading] = useState(false);
const [isForgetPassword, setIsForgetPassword] = useState<boolean>(false);
  const initialValues = {
    email: "",
    password: ""

  };

  const handleLoginSubmit = async (values: typeof initialValues) => {
    setLoading(true);
    try {
      const {token, success,data,username } = await authService.orgLogin({
        username: values.email,
        password: values.password,
      });
      if (success) {
        setLoading(false);
        tokenManager.removeToken();
        tokenManager.setToken(token);
        LocalStorageManager.removeUserName();
        LocalStorageManager.removeOrgdata();
        username&&LocalStorageManager.setUserName(username);
        data && LocalStorageManager.setOrgdata(JSON.stringify(data));
        navigate(routes.userLayout); // go to org layout
      } else {
        setLoading(false);
        Swal.fire({
          title: "Error",
          text: "Failed to Login",
          icon: "error",
          confirmButtonText: "OK",
        })
      }

    } catch (err) {
      setLoading(false);
       Swal.fire({
          title: "",
          text: "Failed to Login",
          icon: "error",
          confirmButtonText: "OK",
        })
      console.log('Failed to Login', err);
    }

  }

  const checkEmailUnique = async (email: string) => {
    if (!email) return true;
    try {
      tokenManager.removeToken();
      const {success} = await organizationService.checkEmailUnique(email);
      if (success === false) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.error("Email validation error:", err);
      return false; 
    }
  };

  const checkMobileUnique = async (mobileNo: string) => {
    if (!mobileNo) return true;
    try {
      tokenManager.removeToken();
      const {success } = await organizationService.checkMobileUnique(mobileNo);
      if (success === false) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.error("Mobile validation error:", err);
      return false;
    }
    
  };
  const handleRegisterSubmit = async (values: {
    organizationName: string;
    email: string;
    contactNumber: string;
    password: string;
    confirmPassword: string;
  }) => {
    try {
      setLoading(true);
      const organizationInfo = {
        ...values,
        createdon: moment().format('YYYY-MM-DD'),
        posttime: moment().format('h:mm:ss'),
      }
      const formData = new FormData();
      formData.append("organizationInfo", JSON.stringify(organizationInfo));
      tokenManager.removeToken();
      const { success } = await organizationService.createOrganization(formData);
      if (success) {
        setLoading(false);
        Swal.fire({
          title: "Success",
          text: "Link to create password has been emailed, please check your registered Email.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(async (result) => {
            navigate(routes.home);
        });
      }
    } catch (err) {
      setLoading(false);
      Swal.fire({
        title: "Error",
        text: "organization creation failed",
        icon: "error",
        confirmButtonText: "OK",
      })
      console.log('error in organization creation', err);
    }

  };

  const loginSchema = Yup.object({
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string().min(4, "Min 4 characters").required("Password is required"),

  });

  const registerSchema = Yup.object({
    organizationName: Yup.string().required("Organization name is required"),
    email: Yup.string()
      .email("Invalid email")
      .required("Email is required")
       .test(
      "unique-email",
      "Email already exists",
      async function (value) {
        if (!value) return true; // ✅ important
        try {
          const isUnique = await checkEmailUnique(value);
          return isUnique;
        } catch {
          return this.createError({ message: "Unable to validate email" });
        }
      }
    ),
        
    contactNumber: Yup.string()
      .matches(/^[0-9]{10}$/, "Mobile must be 10 digits")
      .required("Mobile number is required")
      .test(
      "unique-mobile",
      "Mobile number already exists",
      async function (value) {
        if (!value) return true; // ✅ important
        try {
          const isUnique = await checkMobileUnique(value);
          return isUnique;
        } catch {
          return this.createError({ message: "Unable to validate mobile number" });
        }
      }),
    //password: Yup.string().min(6, "At least 6 chars").required("Password required"),
    /*confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Passwords must match")
      .required("Confirm password is required"),*/
  });
  

  return (
    <>
    <MainHeader/>
    <div className="login-page-wrap d-flex align-items-center justify-content-center bg-light">
      
      <div className="card shadow-lg border-0 rounded-4 overflow-hidden" style={{ maxWidth: "850px", width: "100%" }}>
        <div className="row g-0">
          {/* Left Section – Upcoming Events */}
          <div className="col-md-5 login-left-panel text-black p-4 d-flex flex-column align-items-center justify-content-center">
            <h5 className="fw-bold text-center mb-4"></h5>
            <div className="text-center mb-4 d-flex flex-column gap-4">
              <a
                href="https://cpdonlinetgmc.in/upcoming-events"
                className="fw-semibold text-decoration-none"
                target="_blank"
                rel="noreferrer"
              >
                Upcoming Events
              </a>
              <a
                href="/assets/CPD_user_instructions.pdf"
                className="fw-semibold text-decoration-none"
                target="_blank"
                rel="noreferrer"
              >
                CPD User Instructions manual
              </a>
            </div>
          </div>

          {/* Right Section – Login / Register */}
          <div className="col-md-7 bg-white p-4">
            <div className="d-flex justify-content-between mb-4 border-bottom pb-2">
              <button
                className={`${
                  !isRegister ? "btn-submit" : "btn btn-outline-primary"
                } rounded-pill`}
                onClick={() => setIsRegister(false)}
              >
                Organization Login
              </button>
              <button
                className={`${
                  isRegister ? "btn-submit" : "btn btn-outline-primary"
                } rounded-pill`}
                onClick={() => setIsRegister(true)}
              >
                New Organization/ Signup
              </button>
            </div>

            {!isRegister ? (
              <>
                <h5 className="text-center mb-3 fw-semibold"> Welcome to Telangana Medical Council CPD Program</h5>
                <Formik
                  initialValues={{ email: "", password: "" }}
                  validationSchema={loginSchema}
                  onSubmit={handleLoginSubmit}
                  validateOnChange={false}
                  validateOnBlur={true}
                >
                  {({ handleSubmit }) => (
                    <Form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <Field
                          name="email"
                          type="email"
                          className="form-control"
                          placeholder="Enter email"
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="text-danger small"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Password</label>
                        <Field
                          name="password"
                          type="password"
                          className="form-control"
                          placeholder="Enter password"
                        />
                        <ErrorMessage
                          name="password"
                          component="div"
                          className="text-danger small"
                        />
                      </div>

                      <button type="submit" className="btn-submit w-100"
                         disabled={loading} >
                          {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Logging in...
                  </>
                ) : (
                  "Login"
                )}
                        </button>
                        <div className="w-100 text-center mb-3">
                         <Link to={"/"} className="fs-14" data-bs-toggle="modal" onClick={() => { setIsForgetPassword(false) }} data-bs-target="#ForgotPassword">Reset/Forgot password?</Link>
                        </div>
                      
                    </Form>
                  )}
                </Formik>
              </>
            ) : (
              <>
                <h5 className="text-center mb-3 fw-semibold">Create Account</h5>
                <Formik
                  initialValues={{
                    organizationName: "",
                    email: "",
                    contactNumber: "",
                    password: "",
                    confirmPassword: "",
                  }}
                  validationSchema={registerSchema}
                  validateOnChange={false}
                  validateOnBlur={true}
                  onSubmit={handleRegisterSubmit}
                >
                  {({ handleSubmit }) => (
                    <Form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label>Organization Name</label>
                        <Field name="organizationName" type="text" className="form-control" />
                        <ErrorMessage name="organizationName" component="div" className="text-danger small" />
                      </div>
                      <div className="mb-3">
                        <label>Email</label>
                        <Field name="email" type="email" className="form-control" />
                        <ErrorMessage name="email" component="div" className="text-danger small" />
                      </div>
                      <div className="mb-3">
                        <label>Mobile No</label>
                        <Field name="contactNumber" type="text" className="form-control" />
                        <ErrorMessage name="contactNumber" component="div" className="text-danger small" />
                      </div>
                      {/*
                      <div className="mb-3">
                        <label>Password</label>
                        <Field name="password" type="password" className="form-control" />
                        <ErrorMessage name="password" component="div" className="text-danger small" />
                      </div>
                      <div className="mb-3">
                        <label>Confirm Password</label>
                        <Field name="confirmPassword" type="password" className="form-control" />
                        <ErrorMessage
                          name="confirmPassword"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                      */}
                      <button type="submit" className="btn-submit fw-semibold w-100">
                        
                         {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2 "
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Submitting in...
                  </>
                ) : (
                  "Submit"
                )}
                      </button>
                    </Form>
                  )}
                </Formik>
              </>
            )}
          </div>
        </div>
      </div>
                <div className="modal fade" id="ForgotPassword" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                         <div className="modal-content">
                          <ResetPasswordFlow></ResetPasswordFlow>
                        </div>
                       </div>
                       </div>

    </div>
  </>);
};

export default LoginPage;
